<button [disabled]="disabled === true" type="submit" class="btn" [ngClass]="getClass()">{{value}}</button>
